import {log} from "util";

export const layoutsMix = {
  data() {
    return {
      itemsLayout: [],
      layoutActive: {},
      layouts: []
    }
  },
  methods: {
    clearSelectLayout(){
      this.layoutsGroup[this.currentLayoutCroupIndex].objects = this.layoutsGroup[this.currentLayoutCroupIndex].objects.map((el)=>{
        el[3] = false
        return el
      })
    },
    lockLayout(index) {
      console.log('index',index)
      this.layoutsGroup[index].objects.map((el) => {
        if (this.layoutsGroup[index].lock) {
          this.setLockObjectToggle(el[4], false)
        } else {
          this.setLockObjectToggle(el[4], true)
        }
      })
      this.layoutsGroup[index].lock = !this.layoutsGroup[index].lock
    },
    showLayout(index) {
      console.log('showLayout',index)
      let bool =   !this.layoutsGroup[index].show
      this.layoutsGroup[index].objects.map((el) => {
          this.setVisibleObjectToggle(el[4], bool)
      })
      this.layoutsGroup[index].show = !this.layoutsGroup[index].show

    },
    selectFolder(item) {
      console.log('itemFolder', item)
      let arr = this.layoutsGroup[this.currentLayoutCroupIndex].objects.map((el) => {
        el[3] = false
        return el
      })
      this.layoutsGroup[this.currentLayoutCroupIndex].objects = arr
      this.canvas.discardActiveObject().renderAll();
      this.currentLayoutCroupIndex = item.i
      this.typeAction = 'folder'
    },
    changeActiveObjects(item) {
      console.log('item', item)
      let obj = this.canvas.getObjects().filter(el => el.id === item[4])[0]
      console.log('obj', obj)
      this.canvas.discardActiveObject().renderAll()
      if (!item[2]) this.canvas.setActiveObject(obj).renderAll()
      this.changeActive(item)
    },
    changeActive(array) {
      // console.log('array',array)
      const aaa = [array[4]]
      const arr = this.layoutsGroup.map((element) => {
        element.objects.map(
          (el) => {
            if (aaa.includes(el[4])) {
              el[3] = true
            } else {
              el[3] = false
            }
            return el
          }
        )
        return element
      })
      this.layoutsGroup = arr
      this.setCurrentLayoutCroupIndex(array[7])
    },
    deleteLayoutElement(element) {
      console.log('index', element.index)
      console.log('element', element)
      let index = this.layoutsGroup[element.index].objects.map(e => e[4]).indexOf(element.id)
      this.layoutsGroup[element.index].objects.splice(index, 1)
      // this.layoutsGroup.map((el)=>{
      //   el.objects.
      // })
      // let index = this.itemsLayout.map(e => e[6]).indexOf(id)
      // console.log(index)
      // this.itemsLayout.splice(index, 1)
    },
    copyLayout() {
      this.copyElement()
    },
    changeNameObject(item) {
      console.log('asfsdf', item)
      let arr = this.layoutsGroup[item.index].objects.map((el) => {
        if (el[4] === item.obj.id) el[8] = item.name
        return el
      })
      this.layoutsGroup[item.index].objects = arr

    },
    downFolder(folder) {
      let index = this.currentLayoutCroupIndex
      let group = this.layoutsGroup
      let temp = group[index]
      group[index] = group[index+1]
      group[index+1] = temp
      this.currentLayoutCroupIndex = index+1

      this.layoutsGroup =group.map((ele,i)=>{
        ele.objects.map((elem)=>{
          this.canvas.getObjects().filter(ell=>ell.id === elem[4])[0].set('index',i)
          elem[7] = i
          return elem
        })
        return ele
      })






    },
    upFolder(folder) {
      let index = this.currentLayoutCroupIndex
      let group = this.layoutsGroup

      let temp = group[index]
      group[index] = group[index-1]
      group[index-1] = temp
      this.currentLayoutCroupIndex = index-1

      this.layoutsGroup = group.map((ele,i)=>{
        ele.objects.map((elem)=>{
          this.canvas.getObjects().filter(ell=>ell.id === elem[4])[0].set('index',i)
          elem[7] = i
          return elem
        })
        return ele
      })

    },
    hideZoomEvent(item) {
      console.log((item));
      if (item.event === 'all') {
        this.layoutsGroup[this.currentLayoutCroupIndex].event = {
          type: 'all',
          value: 0
        }
      }

      if (item.event === 'opacity') {
        this.layoutsGroup[this.currentLayoutCroupIndex].event = {
          type: 'opacity',
          value: this.canvas.getZoom()
        }
      }

      if (item.event === 'opacityDown') {
        this.layoutsGroup[this.currentLayoutCroupIndex].event = {
          type: 'opacityDown',
          value: this.canvas.getZoom()
        }
      }


    },
    changeNameFolder(item) {
      this.layoutsGroup[item.index].name = item.name
    },
    deleteLayout() {
      this.deleteElementCanvas()
    },
    downLayout() {
      console.log('down')
    },
    upLayout() {
      console.log('up')
    }
  }
}
